import React from "react";
import Logo from "../Icons/Logo.js";
import s from "./Footer.module.scss";

const Footer = () => {
  return (
    <div className={s.footer}>
      <span className={s.footerLabel}>2022 &copy; SG Referrals Asia <Logo /> </span>
    </div>
  )
}

export default Footer;
